
export default {
    'Gutter': {
        Mobile: 20,
        Tablet: 25,
        Laptop: 40,
        Desktop: 50,
        BigDesktop: 75
    },
    'GutterGrid': {
        Mobile: 20,
        Tablet: 25,
        Laptop: 40,
        Desktop: 50,
        BigDesktop: 75
    },
    'MenuHeight': {
        Mobile: 58,
        Tablet: 65,
        Laptop: 95,
        Desktop: 95,
        BigDesktop: 95
    },
    'panelTextMaxWidth': {
        Small: 650,
        Big: 850
    }
};


// WEBPACK FOOTER //
// ./src/constants/spacing.ts